module.exports = __webpack_public_path__ + "img/Maat.7756676d.png";